import {deletedHeartRunnerListState} from '../state/deletedHeartRunnerState';
import {Fetch_All_Region_Data1,Fetch_Deleted_List, Update_Request, Update_Delete_Response,
            Update_Approve_Response} from '../actions/deletedHeartRunnerAction';

export function deletedHeartRunnerReducer(state = deletedHeartRunnerListState, action) {
    switch (action.type) {
        case Fetch_Deleted_List:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                deletedHeartRunnerList : action.deletedList
        })
        case Update_Request:
            return Object.assign({}, state,{
                errorCode : 0,
                statusCode : 0,
                message : '',
            })
        case Update_Delete_Response:
            return Object.assign({}, state,{
                message : action.message,
                errorCode : action.errorCode,
                statusCode : action.statusCode
            })
        case Update_Approve_Response :
            return Object.assign({}, state,{
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message : action.message,
                deletedHeartRunnerList : action.list
            })
             case Fetch_All_Region_Data1:
                                            return Object.assign({}, state, {
                                                errorCode : action.errorCode,
                                                statusCode : action.statusCode,
                                                regionList : action.regionList
                                            })
        default:
            return state;
    }
}
